var map = {
	"./br.svg": 1606,
	"./cn.svg": 1607,
	"./de.svg": 1608,
	"./dk.svg": 1609,
	"./es.svg": 1610,
	"./fi.svg": 1611,
	"./fr.svg": 1612,
	"./gb.svg": 1613,
	"./hk.svg": 1614,
	"./hu.svg": 1615,
	"./id.svg": 1616,
	"./il.svg": 1617,
	"./it.svg": 1618,
	"./jp.svg": 1619,
	"./kr.svg": 1620,
	"./my.svg": 1621,
	"./nl.svg": 1622,
	"./no.svg": 1623,
	"./pl.svg": 1624,
	"./pt.svg": 1625,
	"./ru.svg": 1626,
	"./sa.svg": 1627,
	"./se.svg": 1628,
	"./th.svg": 1629,
	"./tr.svg": 1630,
	"./tw.svg": 1631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1605;